import Notification from "models/notification"
import IState from "../state"

export const getNotifications = (state: IState): Notification[] =>
  state.notification.notifications
